<template>
    <div class="store-logo">

        <h5>Logo <a href="javascript:void(0);" @click="editLogo()"><i class="mdi mdi-square-edit-outline"></i></a></h5>

        <div v-if="!editingLogo">
            <div v-if="image">
                <img :src="image" class="img-fluid store-logo-img">
            </div>
            <div v-else>
                -
            </div>
        </div>

        <div v-if="editingLogo">
            <input type="file" v-on:change="onFileChange" class="form-control">
            <div class="mt-2">
                <button class="btn btn-secondary" @click="cancelEditLogo()">Abbrechen</button>
                <button class="btn btn-primary" @click="saveLogo()">Speichern</button>
            </div>
        </div>

    </div>
</template>

<script>
    export default {

    	data() {
            return {
                image: '',
                logo_filename: '',
                editingLogo: ''
            };
        },

        mounted() {
            if(this.storeData.logo_filename)
                this.image = '/images/logos/' + this.storeData.logo_filename;
            else
                this.image = false;
        },

        methods: {

            editLogo() {
                this.editingLogo = true;
            },
            cancelEditLogo() {
                this.editingLogo = false;
            },
            onFileChange(e) {
                let files = e.target.files || e.dataTransfer.files;
                if (!files.length)
                    return;
                this.createImage(files[0]);
            },
            createImage(file) {
                let reader = new FileReader();
                let vm = this;
                reader.onload = (e) => {
                    vm.image = e.target.result;
                };
                reader.readAsDataURL(file);
            },
            saveLogo() {
                var _this = this;
                axios.post('/stores/' + this.storeData.id + '/upload', {image: this.image}).then(response => {
                    if(response.data.fileName) {
                        _this.image = '/images/logos/' + response.data.fileName;
                        _this.editingLogo = false;
                    }
                });
            }

        },

        props: ['storeData'],

    }
</script>